import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiClientService } from './api-client.service';
import { GetFormSubjectResponse } from '../Models/Responses/GetFormSubjectResponse';
import { GetAppParametersResponse } from '../Models/Responses/GetAppParametersResponse';
import { HttpParams } from '@angular/common/http';
import { GetDeliveryDictionaryResponse } from '../Models/Responses/GetDeliveryDictionaryResponse';
import { AgreementConstraintsDto } from '../Models/AgreementConstraintsDto';
import { GetAddressTypesResponse } from '../Models/Responses/GetAddressTypesResponse';

@Injectable({
  providedIn: 'root',
})
export class DictionaryService {

  private readonly apiService = inject(ApiClientService);

  public getFormSubjects(): Observable<GetFormSubjectResponse> {
    return this.apiService.get<GetFormSubjectResponse>(`api/dictionaries/contacts/subjects`, false);
  }

  public getAppParams(): Observable<GetAppParametersResponse> {
    return this.apiService.get<GetAppParametersResponse>('api/dictionaries/params', false);
  }

  public getAgreementConstraints (caseIdHash: string) : Observable<AgreementConstraintsDto> {
    const params = new HttpParams()
      .set('caseIdHash', caseIdHash);

    return this.apiService.get<AgreementConstraintsDto>(`api/dictionaries/agreements/agreement-constraints?${params.toString()}`, false);
  }

  public getAddressTypes(): Observable<GetAddressTypesResponse> {
    return this.apiService.get<GetAddressTypesResponse>('api/dictionaries/configs/address-types', false);

  }

  public getDeliveryParams (caseIdHash: string): Observable<GetDeliveryDictionaryResponse> {
    const params = new HttpParams()
      .set('caseIdHash', caseIdHash);

    return this.apiService.get<GetDeliveryDictionaryResponse>(`api/dictionaries/agreements/delivery-types?${params.toString()}`, false);
  }
}
